import * as importConstant from './constants'

const initialState = {
  list: [],
  listNCC: [],
  listKHO: [],
  listEXP: [],
  item: {},
  type: importConstant.IMPORT_REPORT_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function productsReducer(state = initialState, action) {
  switch (action.type) {
    case importConstant.IMPORT_REPORT_NCC_REQUESTING:
      return {
        type: action.type,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đanh lấy dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case importConstant.IMPORT_REPORT_NCC_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNCC: action.data ? action.data.records : [],
        item: action.data || {},
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case importConstant.IMPORT_REPORT_NCC_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case importConstant.IMPORT_REPORT_KHO_REQUESTING:
      return {
        type: action.type,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đanh lấy dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case importConstant.IMPORT_REPORT_KHO_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKHO: action.data.records,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case importConstant.IMPORT_REPORT_KHO_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case importConstant.IMPORT_REPORT_LIST_REQUESTING:
      return {
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đanh lấy dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case importConstant.IMPORT_REPORT_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data.records,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case importConstant.IMPORT_REPORT_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case importConstant.IMPORT_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
        formData: action.payload,
        callback: action.callback,
      }

    case importConstant.IMPORT_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listEXP: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case importConstant.IMPORT_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Reports/ImportReport/reducer.js